import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { DataGridDollarPercentChangeComboCell } from "~/components/DataGrid/DataGridDollarPercentChangeComboCell";
import { AssetTableRowData } from "../types";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

// // // //

export const HYPOTHETICAL_10K_PERFORMANCE_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.hypothetical_10_000_performance,
    label: "Hypothetical $10,000 Performance",
    tooltip: CatalogMetricSlugs.hypothetical_10_000_performance,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.hypothetical_10_000_performance,
    width: 220,
    render: (item) => {
        const measure = getMeasureValue(
            item,
            "hypothetical_10_000_performance",
        );

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridDollarPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};
